import { push, replace } from '@takeshape/redux-little-router';
import { getRuntimeSchema, getScratchRuntimeSchema } from 'app/branches/selectors';
import { getRouter } from 'app/selectors';
import { expandPanel } from 'app/workbench';
import type { SagaIterator } from 'redux-saga';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { createBranchPath } from '../branches/utils';
import { API_PANEL_EXPLORER } from '../workbench/constants';
import { type PreviewQueryPayload, previewQuery } from './slice';
import { getShapeQueryName } from './util/get-query';

export function* handlePreviewQuery({ payload }: { payload: PreviewQueryPayload }): SagaIterator {
  let schema = yield select(getScratchRuntimeSchema);
  schema ||= yield select(getRuntimeSchema);

  // If we're in a project but not on a Workbench route, go to the Workbench
  const router = yield select(getRouter);
  const projectId = router.params?.projectId;
  const branch = router.params?.branch;
  if (projectId && !router.route.startsWith('/project/:projectId/branch/:branch/api')) {
    yield put(push(`${createBranchPath(projectId, branch)}/api`));
  }

  // Set the queryName and expand API Explorer panel in the URL query args
  const queryName = payload.queryName ? payload.queryName : (getShapeQueryName(schema, payload.shapeName) ?? 'search');
  yield put(replace({ query: { ...router.query, previewQuery: queryName } }));
  yield put(expandPanel(API_PANEL_EXPLORER));
}

export default function* root(): SagaIterator {
  yield all([takeLatest(previewQuery, handlePreviewQuery)]);
}
